define('app/services/sePlayApiSrv',[
  'lodash',
  'jsml',
  'jquery',

  'app/services/seApiSrv',
  'app.env',

  'app/helper/logging.se'

], function (
  _,
  _jsml,
  $,
  seApi,
  ENV,
  seLogging
) {

  var LOG_LABEL = 'PLAY API SRV'

  var PlayApiService = function () {
    var _v = {
        surveyId: ENV.survey_name,
        playId: ENV.play_sid,
        sessionUId: null
      },
      _fn = {
        utils: {
          getUiSessionId: function () {

            if (_v.sessionUId)
              return _v.sessionUId

            var paramName = 'UISID'

            var cookies = document.cookie.split(';'),
              sessionUId

            _.forEach(cookies, function (cookie) {
              cookie = cookie.trim().split('=')
              if (cookie[0] == paramName) {
                sessionUId = cookie[1]
              }
            })

            if (!sessionUId) {
              console.error(LOG_LABEL, 'Session Id missing', cookies)
              return
            }

            _v.sessionUId = sessionUId

            return sessionUId

          },
          createApiCallUri: function (params) {
            // get parameters from current URI string, e.g. screen, survey_name, etc.
            var apiUri = ENV.play_api_url,
              searchParams = {},
              searchStr

            if (location.search !== '') {
              location.search.substr(1).split('&').map(function (p) {
                var tmpParam = p.split('=')
                searchParams[tmpParam[0]] = tmpParam[1]
              })
            }
            if (params) {
              Object.keys(params).map(function (key) {
                searchParams[key] = params[key]
              })
            }

            searchStr = Object.keys(searchParams).reduce(function (r, v, k, arr) {
              return r + (r === '' ? '?' : '&') + v + '=' + searchParams[v]
            }, '')

            return apiUri + searchStr
          },
          getStatusHeaderObj: function (xhrObj) {

            var headerFields = {
                // var name         // header field name
                int: {
                  progress: 'percent-complete'
                },
                boolean: {
                  isLastPage: 'final-page',
                  isPreview: 'is-preview',
                  hideControls: 'hide-controls',
                  isExample: 'is-example',
                  validationErrors: 'validation-errors'
                },
                json: {
                  //validationErrors:   'validation-errors'
                },
                string: {
                  fieldPrefix: 'field-prefix',
                  errorUri: 'error-url',
                  forcedRedirect: 'forced-redirect',
                  pageId: 'page-id',
                  unselectedValue: 'unselected-value',
                  body: 'body',
                  title: 'title'
                }
              },
              statusObj = {},
              tmpVal,
              tmpSrc

            _.forEach(headerFields, function (fields, type) {
              _.forEach(fields, function (fieldName, varName) {

                tmpVal = null

                if (xhrObj) {
                  tmpSrc = xhrObj.getResponseHeader(fieldName)
                } else {
                  tmpSrc = $('#var_' + fieldName).text().trim()
                }

                switch (type) {
                  case 'int':
                    tmpVal = parseInt(tmpSrc)

                    break
                  case 'boolean':

                    if (parseFloat(tmpSrc) + '' === tmpSrc) {
                      tmpSrc = parseFloat(tmpSrc)
                    } else if (parseInt(tmpSrc) + '' === tmpSrc) {
                      tmpSrc = parseInt(tmpSrc)
                    } else if (tmpSrc === 'null') {
                      tmpSrc = false
                    }

                    tmpVal = !!tmpSrc

                    break
                  case 'json':

                    tmpVal = JSON.parse(tmpSrc)

                    break
                  default:
                    tmpVal = tmpSrc

                    break
                }

                statusObj[varName] = tmpVal
              })
            })

            return statusObj
          },
          xmlToJsml: function (dataXml) {
            var dataJsml

            if (dataXml) {
              dataJsml = JsonML.fromXML(dataXml, function (jml, xml) { // TODO: use this method also in default API XML->JSML conversion

                var filderedOutElementsCnt = 0,
                  filtered = _.filter(jml, function (elm, i) {

                    // filter out line breaks "\n     " in XML that are interpreted as text elements
                    if (elm && elm.match && elm.match(/^\n\s*$/m) && elm.trim() == '') {
                      filderedOutElementsCnt++
                      return false
                    }

                    return true

                  })

                return filtered

              })

              if (dataJsml && dataJsml.length && dataJsml[0] == '') {
                dataJsml = dataJsml[1]
              }

            }

            return dataJsml
          }
        },
        api: {
          _query: function (method, op, dataPackage, succCb, errCb) {
            succCb = succCb || function () {}
            errCb = errCb || function () {}

            dataPackage = dataPackage || {}

            var uri
            //= _fn.utils.createApiCallUri();
            //uri = location.protocol + "//"  + location.host + "/new_play/"; // TODO: remove later when real API is implemented

            var queryType,
              readDataFn

            switch (op) {
              case 'prev':
              case 'next':

                uri = _fn.utils.createApiCallUri({
                  return_type: 'xml'
                })

                dataPackage.form_name = 'playback_form'

                queryType = 'queryXml'
                readDataFn = function (xmlData, xhr) {
                  var status = _fn.utils.getStatusHeaderObj(xhr),
                    jsml

                  if (!status.forcedRedirect) {
                    jsml = _fn.utils.xmlToJsml(xmlData)
                  }

                  return {
                    jsml: jsml,
                    status: status
                  }
                }

                break
              case 'dom': // DEPRECATED

                queryType = 'queryText'
                readDataFn = function (dataHtml) {
                  var $shadowDom = $('<div/>')

                  $shadowDom.html(dataHtml)

                  return $shadowDom
                }

                break
              default: // DEPRECATED
                queryType = 'queryForm'
                readDataFn = function (dataHtml) {
                  var $shadowDom = $('<div/>')

                  $shadowDom.html(dataHtml)

                  return $shadowDom
                }

                break
            }

            var queryPromise = $.Deferred()

            var apiCall = function (retrying) {

              seApi[queryType](
                uri,
                method,
                op,
                dataPackage,
                function succ (data, status, xhr) {

                  queryPromise.resolve() // resolving after new hash is saved

                  var res = readDataFn(data, xhr)

                  succCb(res)
                },
                function err (errorData, statusCode, xhr, req) {
                  // status codes
                  // 500 system error

                  var ignoreError = false

                  switch (parseInt(statusCode)) {
                    case 504:
                      // timeout error > retry in action ?
                      if (errorData.status === 'retry') {

                        // handled in ApiSrv && connectionstatus

                      }

                      break
                    case 0:
                    case 500:
                    default:

                      // handled in ApiSrv

                      break
                  }

                  queryPromise.resolve() // resolving after new hash is saved

                  var
                    errObj = new seApi.ApiError(
                      errorData.message || 'error on api call',
                      {
                        queryType: queryType,
                        uri: uri,
                        method: method,
                        op: op,
                        data: dataPackage,
                        headers: xhr.getAllResponseHeaders(),
                        res: errorData
                      })

                  if (errCb && !ignoreError) {
                    errCb.apply(this, [statusCode, errorData.message, errObj])
                  }

                }
              )

            }

            apiCall()

            return queryPromise

          }
        }

      },
      fn = {
        getIndex: function (succCb, errCb) {
          // expects xml to be already rendered in the template

          var xmlStrRaw = $('#index_xml').value(),
            xmlStr = xmlStrRaw ? xmlStrRaw.trim() : null,
            jsmlObj = xmlStr ? _fn.utils.xmlToJsml($.parseXML(xmlStr)) : null

          if (jsmlObj) {
            succCb(jsmlObj)

          } else {

            errCb(404, 'index data not found in template')
          }

        },
        getPage: function (succCb, errCb) {
          // expects xml to be already rendered in the template

          var xmlStr = $('#page_xml').value().trim(),
            jsmlObj = _fn.utils.xmlToJsml($.parseXML(xmlStr)),
            resObj = {
              jsml: jsmlObj,
              status: _fn.utils.getStatusHeaderObj()
            }

          if (jsmlObj) {
            succCb(resObj)

          } else {

            errCb(404, 'page data not found in template')
          }

        },
        sendForm: function (formData, succCb, errCb) {

          _fn.api._query('POST', 'next', formData, succCb, errCb)

        },
        goBack: function (succCb, errCb) {

          var data = {
            PLAYSID: ENV.play_sid,
            form_name: 'playback_form'
          }

          _fn.api._query('POST', 'prev', data, succCb, errCb)
        }
      }

    for (var i in fn) this[i] = fn[i]
    return this
  }

  return new PlayApiService()
})
;
